<template>
    <div class="chat">
        <span class="chat-title">{{ $t('talk.chat') }}</span>
        <div class="chat-body" ref="scrollBody">
            <span
                class="comment"
                v-for="message in messages"
                :key="`comment-${getMessageId(message)}`"
                :class="{ 'current-user': message.user_id === currentUser.id }"
            >
                <span>
                    {{ message.content }}
                </span>
            </span>
        </div>
        <div class="chat-footer">
            <b-input-group>
                <b-form-input
                    v-model="$v.form.newMessage.$model"
                    :state="checkState('newMessage')"
                    @keypress.enter.prevent="sendMessage()"
                ></b-form-input>
                <b-input-group-append>
                    <b-button variant="primary" @click="sendMessage()">
                        <i class="fa fa-send"></i>
                    </b-button>
                </b-input-group-append>
            </b-input-group>
            <span class="enter-message">
                {{ $t('talk.form.pressEnter') }}
            </span>
        </div>
    </div>
</template>

<script>
import { sendComment } from './api'

import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'Chat',
    mixins: [validationMixin],
    props: {
        comments: Array,
        feedbackId: Number,
    },
    validations: {
        form: {
            newMessage: {
                required,
                minLength: minLength(1),
            },
        },
    },
    data() {
        return {
            messages: [],
            form: {
                newMessage: null,
            },
        }
    },
    mounted() {
        this.sortComments()
        this.scrollToBottom()
    },
    updated() {
        this.$nextTick(() => this.scrollToBottom())
    },
    methods: {
        sortComments() {
            if (!this.comments.length) {
                return
            }
            this.messages = this.comments.sort((a, b) => {
                const dateA = new Date(a.created_at)
                const dateB = new Date(b.created_at)

                return dateA - dateB
            })
        },
        sendMessage() {
            if (this.$v.form.newMessage.$invalid) {
                return
            }
            const message = {
                created_at: this.getNowDate(),
                content: this.form.newMessage,
                user_id: this.currentUser.id,
            }

            this.messages.push(message)
            this.form.newMessage = null
            this.$v.$reset()
            this.sendToApi(message)
        },
        checkState(value) {
            const field = this.$v.form[value]
            return field.$dirty ? !field.$invalid : null
        },
        getNowDate() {
            const today = new Date()
            const date = `${today.getFullYear()}-${today.getMonth() +
                1}-${today.getDate()}`
            const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`

            return `${date} ${time}`
        },
        getMessageId(message) {
            return message.id ? message.id : Math.random() * 10
        },
        scrollToBottom() {
            const container = this.$refs.scrollBody
            if (!container) {
                return
            }
            container.scrollTop = container.scrollHeight
        },
        sendToApi({ content, user_id }) {
            const comment = {
                commentable_type: 'feedback',
                commentable_id: this.feedbackId,
                content,
                user_id,
            }

            sendComment(comment)
                .then(() => {})
                .catch(e => console.log(e))
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
    },
}
</script>

<style lang="sass" scoped>
.chat
    padding: 20px
    display: flex
    flex-direction: column
    .chat-title
        font-size: 17px
        color: #6e6e6e
        font-weight: 700
        margin-bottom: 10px
        display: block
    .chat-body
        display: flex
        width: 100%
        margin-bottom: 10px
        flex-direction: column
        align-items: flex-start
        max-height: 200px
        overflow-y: auto
        overflow-x: hidden
        .comment
            display: flex
            justify-content: center
            align-items: center
            padding: 8px
            background-color: #E1F2FB
            max-width: 80%
            font-size: 13px
            border-radius: 6px
            margin-bottom: 6px
            span
                display: inline-block
                overflow-wrap: break-word
                width: 100%
        .current-user
            background-color: #DCF8C6
            align-self: flex-end
    .chat-footer
        width: 100%
        .enter-message
            font-size: 12px
            margin-top: 5px
            color: #A1A8AF
</style>
